module.exports = __webpack_public_path__ + "static/media/ramen-busd.d6734f88.svg";